<template>
  <base-container style="height: 100%;">
    <div style="height: 32px; text-align: center;position: absolute;top: 2px;z-index: 100;left: 0;right: 0;">
      <el-radio-group v-model="reserveType" size="small">
        <el-radio-button label="JcWorkStation">检查预约</el-radio-button>
        <el-radio-button label="JyWorkStation">检验预约</el-radio-button>
        <el-radio-button label="ZlWorkStation">治疗预约</el-radio-button>
        <el-radio-button label="BedWorkStation">床位预约</el-radio-button>
        <el-radio-button label="OpWorkStation">手术评估</el-radio-button>
      </el-radio-group>
    </div>
    <transition name="el-zoom-in-center">
      <component :is="reserveType"></component>
    </transition>
  </base-container>
</template>

<script>
import JcWorkStation from "./jc/Workstation.vue";
import JyWorkStation from "./jy/Workstation.vue";
import ZlWorkStation from "./zl/Workstation.vue";
import BedWorkStation from "./bed/Reserve.vue";
import OpWorkStation from "./op/OpEvaluateWork";
export default {
  components: { JcWorkStation, JyWorkStation,ZlWorkStation,BedWorkStation,OpWorkStation },
  data() {
    return {
      reserveType: "JcWorkStation",
    };
  },
};
</script>

<style lang="scss" scoped></style>
